import useCustomConfig from "@/composables/useEnvConfig";

export default defineNuxtPlugin(() => {
    !function (t, r, e, a, n, o, i, l, c, s, d, h, u) {
        var f = i + "_q", m = i + "_c";
        t[i] = t[i] || {}, t[f] = t[f] || [], t[m] = t[m] || [];
        for (let r = 0; r < l.length; r++) d(t[i], t[f], l[r]);
        for (let r = 0; r < c.length; r++) {
            var g, b = c[r][0], p = c[r][1];
            t[i][b] = function (...r) {
                return g = this, t[m].push((function () {
                    g[s] = new t[i][b](...r)
                })), g
            };
            for (let r = 0; r < p.length; r++) {
                const e = p[r];
                t[i][b].prototype[e] = function (...r) {
                    t[m].push((function () {
                        g[s][e](...r)
                    }))
                }
            }
        }
        h = r.createElement(e), u = r.getElementsByTagName(e)[0], h.async = !0, h.src = "https://cdn.adjust.com/adjust-latest.min.js", h.onload = function () {
            for (var r = 0; r < t[m].length; r++) t[m][r]();
            t[m] = [];
            for (r = 0; r < t[f].length; r++) t[f][r][1][0][s] ? t[i][t[f][r][0]](t[f][r][1][0][s]) : t[i][t[f][r][0]].apply(t[i], t[f][r][1]);
            t[f] = []
        }, u.parentNode.insertBefore(h, u)
    }(window, document, "script", 0, 0, 0, "Adjust", ["initSdk", "getAttribution", "getWebUUID", "waitForAttribution", "waitForWebUUID", "setReferrer", "trackEvent", "addGlobalCallbackParameters", "addGlobalPartnerParameters", "removeGlobalCallbackParameter", "removeGlobalPartnerParameter", "clearGlobalCallbackParameters", "clearGlobalPartnerParameters", "switchToOfflineMode", "switchBackToOnlineMode", "stop", "restart", "gdprForgetMe", "disableThirdPartySharing", "trackThirdPartySharing", "initSmartBanner", "showSmartBanner", "hideSmartBanner"], [["ThirdPartySharing", ["addGranularOption", "addPartnerSharingSetting"]]], "__realObj", (function (t, r, e) {
        t[e] = function () {
            r.push([e, arguments])
        }
    }));

    const config = useCustomConfig();
    window.Adjust && Adjust.initSdk({
        appToken: config.public.ADJUST_KEY,
        environment: config.public.APP_ENV === "production" ? "production" : "sandbox",
    });
})